// This week's Taco Tuesday deal — Burbank, NoHo & Van Nuys.
//
// The Tuesday deal changes week to week (50% off tacos mulitas one week,
// $1.50 street tacos the next), so everything here is keyed to one specific
// Tuesday in `tuesdayDeal.date`. The banners promote it the 6 days leading up
// to that Tuesday and on the day itself, then disappear on their own — they
// never advertise a deal for a Tuesday it isn't running. To promote next
// week's deal, update the copy and the date. To turn it off, set
// `tuesdayDealEnabled` to false.
//
// Menu items whose name contains one of `highlightNames` get the
// `tuesday-deal-item` class (styled in ./index.scss) while the deal is live;
// see prependTuesdayDealHighlight in src/Context/applyDiscount.js.

export const tuesdayDealEnabled = true

export const tuesdayDeal = {
  date: '2026-10-20', // the Tuesday this deal runs, YYYY-MM-DD (LA time)
  headline: '$1.50 Street Tacos Are Back!',
  extra: '+ $1.99 Taquitos',
  details: 'Handmade tortilla street tacos for $1.50 (limit 10) plus $1.99 loaded taquitos (5 min). Look for the Taco Tuesday Special section on the menu.',
  image: 'https://afag.imgix.net/pablitos-tacos-burbank/tacos-6.jpg',
  highlightNames: ['street taco'],
}

export const tuesdayDealShopIds = [
  'pablitostacosburbank',
  'pablitostacosnoho',
  'pablitostacosvannuys',
]

const DAY_MS = 24 * 60 * 60 * 1000
const LEAD_DAYS = 6

// Today's date in America/Los_Angeles as YYYY-MM-DD, regardless of the user's
// device timezone.
function todayInLA() {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      timeZone: 'America/Los_Angeles',
    }).format(new Date())
  } catch (e) {
    const t = new Date()
    return [t.getFullYear(), String(t.getMonth() + 1).padStart(2, '0'), String(t.getDate()).padStart(2, '0')].join('-')
  }
}

function daysUntilDeal() {
  return Math.round((Date.parse(tuesdayDeal.date) - Date.parse(todayInLA())) / DAY_MS)
}

export function isTuesdayDealUpcoming() {
  if (!tuesdayDealEnabled) { return false }
  const days = daysUntilDeal()
  return days >= 0 && days <= LEAD_DAYS
}

export function isTuesdayDealToday() {
  return tuesdayDealEnabled && daysUntilDeal() === 0
}

export function isTuesdayDealShop(shopId) {
  return tuesdayDealShopIds.indexOf(shopId) !== -1
}

// "Today · Taco Tuesday" on the day, "Tomorrow · Taco Tuesday" on Monday,
// otherwise "This Tuesday, Oct 20".
export function tuesdayDealWhen() {
  const days = daysUntilDeal()
  if (days === 0) { return 'Today · Taco Tuesday' }
  if (days === 1) { return 'Tomorrow · Taco Tuesday' }
  const [y, m, d] = tuesdayDeal.date.split('-').map(Number)
  const label = new Date(y, m - 1, d).toLocaleDateString('en-US', {month: 'short', day: 'numeric'})
  return 'This Tuesday, ' + label
}

function isHighlighted(product) {
  const name = ((product.name && product.name.en) || '').toLowerCase()
  return tuesdayDeal.highlightNames.some((n) => name.indexOf(n) !== -1)
}

// Adds the `tuesday-deal-item` class to the deal's products. Product tags are
// a space/comma separated string that MenuCategoryListView turns into CSS
// classes.
export function highlightTuesdayDealItems(menu) {
  return Object.assign({}, menu, {
    subMenus: menu.subMenus.map((subMenu) => Object.assign({}, subMenu, {
      products: (subMenu.products || []).map((product) => {
        if (!isHighlighted(product)) { return product }
        const tags = [].concat(product.tags || []).join(' ') + ' tuesday-deal-item'
        return Object.assign({}, product, {tags})
      }),
    })),
  })
}
